import React from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import { ChildrenProfileFieldCheckboxItem } from "Signups/FamilyRegistration/Shared/DragNDropCheckboxItem/ProfileFieldCheckboxItem";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import ManageProfileFields from "Signups/FamilyRegistration/Shared/ManageProfileFields";
import {
  Border,
  IconSection,
  IconSectionContent,
  IconSectionIcon,
  IconSectionTitle,
} from "Signups/FamilyRegistration/Shared/StyledComponents";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

import FnrDragNDrop from "UI/FnrDragNDrop";

export default function ExtendedFieldsChildren({ disabled }) {
  const { state } = useFamilyRegistrationContext();
  const selectedPanel = state?.selectedPanel;
  /**
   * canReorder is necessary to allow reordering, but isn't returned from the getAdminSettings endpoint
   * because it will always be true for these fields
   */
  const fields =
    state?.familyRegistrationSettings?.extendedFieldsChildren?.fields.map(
      (field) => {
        return { ...field, canReorder: true };
      }
    );
  const [dndItems, setDndItems] = React.useState();

  const { updateSetting, saving, error, setError } = useUpdateSetting();

  const saveNewOrder = async ({
    id,
    startPosition,
    endPosition,
    orderedItems,
  }) => {
    setDndItems(orderedItems);
    let distance = endPosition - startPosition;

    await updateSetting({
      setting: "extendedFieldsChildren",
      itemID: id,
      value: distance,
      action: "reorder",
    });

    setDndItems(null);
  };

  return (
    <IconSection>
      <IconSectionIcon far fa-id-card />
      <IconSectionContent>
        <IconSectionTitle style={{ marginBottom: 8 }}>
          Which other fields would you like to include when children are
          registered?
        </IconSectionTitle>

        <Border style={{ maxWidth: "360px", padding: 6 }}>
          <FnrDragNDrop
            items={dndItems || fields}
            itemIdName="ID"
            ItemComponent={ChildrenProfileFieldCheckboxItem}
            onRelease={saveNewOrder}
            disabled={Boolean(saving | disabled)}
            itemHasDragTrigger={true}
          />

          {selectedPanel === "children-info" && <ManageProfileFields />}
        </Border>

        <ErrorMessage error={error?.error} />
      </IconSectionContent>
    </IconSection>
  );
}
